import { IntlShape } from 'react-intl';
import { formatTranslation } from 'intl';
import { ProjectSetupTranslationKeys } from 'intl/keys';

interface TranslatedLabels {
  NAME_LABEL: string;
  LANGUAGE_AND_LOCATION: string;
  PROJECT_LANGUAGE: string;
  TIMEZONE: string;
  DEADLINE_AND_BUDGET: string;
  PROJECT_START_DATE: string;
  PROJECT_END_DATE: string;
  PROJECT_CURRENCY: string;
  PROJECT_VALUE: string;
}

export const createTranslatedLabels = (
  intl: IntlShape
): TranslatedLabels => {
  const NAME_LABEL = formatTranslation(intl, ProjectSetupTranslationKeys.shortName,);

  const LANGUAGE_AND_LOCATION = formatTranslation(intl, ProjectSetupTranslationKeys.languageAndLocation,);

  const PROJECT_LANGUAGE = formatTranslation(intl, ProjectSetupTranslationKeys.language,);

  const TIMEZONE = formatTranslation(intl, ProjectSetupTranslationKeys.timezone,);

  const DEADLINE_AND_BUDGET = formatTranslation(intl, ProjectSetupTranslationKeys.deadlineAndBudget,);

  const PROJECT_START_DATE = formatTranslation(intl, ProjectSetupTranslationKeys.startDate,);

  const PROJECT_END_DATE = formatTranslation(intl, ProjectSetupTranslationKeys.endDate);

  const PROJECT_CURRENCY = formatTranslation(intl, ProjectSetupTranslationKeys.currency);

  const PROJECT_VALUE = formatTranslation(intl, ProjectSetupTranslationKeys.value);

  return {
    NAME_LABEL,
    LANGUAGE_AND_LOCATION,
    PROJECT_LANGUAGE,
    TIMEZONE,
    DEADLINE_AND_BUDGET,
    PROJECT_START_DATE,
    PROJECT_END_DATE,
    PROJECT_CURRENCY,
    PROJECT_VALUE,
  };
};
